export const styles = () => ({
  root: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    fontSize: 14,
  },
});
